const cobblImages = [
  
   require('./cobbl1.jpg'),
     require('./cobbl2.jpeg'),
    require('./cobbl6.jpeg'),
    require('./cobbl3.jpeg'),
    require('./cobbl4.jpeg'),
    require('./cobbl5.jpeg'),
   
  ];
  
  export default cobblImages;